import { useLocation } from "react-router-dom";
import Footer from "./Component/Footer/footer.jsx";

/**
 * Pied de page global (même composant que l’accueil), sauf sur les écrans où ce n’est pas pertinent :
 * authentification minimale, vérification e-mail, espace admin.
 */
function shouldHideFooter(pathname) {
  const p = pathname.toLowerCase();
  if (p === "/login" || p.startsWith("/auth/login")) return true;
  if (p.startsWith("/forgot_password") || p.startsWith("/auth/forgot-password")) return true;
  if (p.startsWith("/reset_password") || p.startsWith("/auth/reset-password")) return true;
  if (p.startsWith("/admin/")) return true;
  if (p === "/verification" || p.startsWith("/verification/") || p.startsWith("/auth/verify-email")) return true;
  // ProMeet Missions a sa propre mise en page immersive (sidebar) — pas de footer.
  if (p.startsWith("/missions")) return true;
  return false;
}

export default function AppFooter() {
  const { pathname } = useLocation();
  if (shouldHideFooter(pathname)) return null;
  return <Footer />;
}
